export default __webpack_public_path__ + "static/media/tweet3.4829be8e.png";